export const SECTION_PATHS = {
    home: '/',
    projects: '/projects',
    skills: '/skills',
    contact: '/contact',
};

export const sectionForPath = path =>
    Object.keys(SECTION_PATHS).find(section => SECTION_PATHS[section] === path);

export const isAppPath = path => Boolean(sectionForPath(path)) || path === '/blog' || path.startsWith('/blog/');
